import React from 'react';
import { motion } from 'framer-motion';
import { ProductImage } from './ProductImage';
import { CTAButton } from './CTAButton';
import { ShieldCheck, Clock } from 'lucide-react';
export function PricingSection() {
  return <section id="comprar" className="py-24 px-4 bg-slate-950 relative overflow-hidden" data-id="element-60">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-teal-900/20 via-slate-950 to-slate-950 pointer-events-none" data-id="element-61"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-62">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-63">
          <div className="inline-flex items-center gap-2 bg-red-500/10 text-red-400 px-4 py-2 rounded-full font-bold text-sm uppercase tracking-wider border border-red-500/20 mb-8" data-id="element-64">
            <Clock className="w-4 h-4" data-id="element-65" /> Oferta por tiempo limitado
          </div>
          <h2 className="text-4xl md:text-6xl font-black text-white mb-6" data-id="element-66">
            Este es el momento
          </h2>
          <p className="text-xl text-slate-300 mb-2" data-id="element-67">
            Podés seguir como estás…
          </p>
          <p className="text-2xl font-bold text-teal-400" data-id="element-68">
            O podés dar el paso hacia una práctica profesional real.
          </p>
          <p className="text-xl text-slate-400 mt-6 font-medium" data-id="element-69">
            No mañana. No después.{' '}
            <span className="text-amber-400 font-bold" data-id="element-70">👉 Ahora.</span>
          </p>
        </motion.div>

        <div className="bg-slate-900 border-2 border-teal-500/30 rounded-3xl p-8 md:p-12 shadow-2xl shadow-teal-900/20" data-id="element-71">
          <div className="grid md:grid-cols-2 gap-12 items-center mb-12" data-id="element-72">
            <div data-id="element-73">
              <ProductImage data-id="element-74" />
            </div>
            <div className="text-center md:text-left" data-id="element-75">
              <h3 className="text-3xl font-black text-white mb-2" data-id="element-76">
                KIT ORTOPEDISTA PRO
              </h3>
              <p className="text-teal-400 font-bold mb-8" data-id="element-77">
                + Todos los bonos exclusivos
              </p>

              <div className="mb-8" data-id="element-78">
                <p className="text-slate-400 text-lg mb-1" data-id="element-79">Precio regular:</p>
                <p className="text-3xl text-slate-500 line-through font-bold decoration-red-500/50" data-id="element-80">
                  $49.990
                </p>
              </div>

              <div className="mb-8" data-id="element-81">
                <p className="text-amber-400 font-bold text-xl mb-2" data-id="element-82">
                  Precio único por hoy:
                </p>
                <p className="text-6xl md:text-7xl font-black text-white drop-shadow-lg" data-id="element-83">
                  $19.990
                </p>
                <p className="text-slate-400 mt-2 text-sm" data-id="element-84">
                  Pesos Argentinos. Pago único. Acceso de por vida.
                </p>
              </div>
            </div>
          </div>

          <div className="text-center" data-id="element-85">
            <CTAButton text="ACCEDÉ AL KIT AHORA" href="https://checkout.abastecedordigital.shop/cart/51662528086336:1" className="text-xl md:text-2xl py-5" data-id="element-86" />
            <p className="text-white font-bold text-xl mt-6" data-id="element-87">
              Y empezá a trabajar como un verdadero profesional.
            </p>

            <div className="flex items-center justify-center gap-2 mt-8 text-slate-400 text-sm" data-id="element-88">
              <ShieldCheck className="w-5 h-5 text-teal-500" data-id="element-89" />
              <span data-id="element-90">Pago 100% seguro y encriptado</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}